import { CONSTANTS } from 'constants/Constants';
import oAxiosInstance from 'redux/interceptors/Interceptors';

const VOUCHER_TYPES_URL = CONSTANTS.API_URL + 'vouchertypes';

/**
 * Funcion para tomar todos losDepartamentos de uruguay
 * 
 * 
 * @author Franko Zerpa
 */
export const GetVoucherTypes = () => {
    return oAxiosInstance.get(VOUCHER_TYPES_URL).then(oResult => oResult.data)
}
